import { render, staticRenderFns } from "./PriceBarcodeGenerate.vue?vue&type=template&id=b61971a4&scoped=true&"
import script from "./PriceBarcodeGenerate.vue?vue&type=script&lang=js&"
export * from "./PriceBarcodeGenerate.vue?vue&type=script&lang=js&"
import style0 from "./PriceBarcodeGenerate.vue?vue&type=style&index=0&id=b61971a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61971a4",
  null
  
)

export default component.exports